import { useEffect } from "react";

const MOBILE_VIEWPORT =
  "width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=5, viewport-fit=cover";

const DEFAULT_VIEWPORT = "width=device-width, initial-scale=1";

const BODY_CLASS = "mobile-viewport-active";

/**
 * Sets mobile-friendly viewport meta. Fixes incorrect scaling on iOS/Android
 * while keeping zoom available. Restores default viewport on unmount.
 * Adds a body class so CSS can prevent zoom-on-focus for inputs (e.g. 16px min font-size).
 */
export function useMobileViewport() {
  useEffect(() => {
    const meta = document.querySelector('meta[name="viewport"]');
    if (!meta) return;
    const previous = meta.getAttribute("content") ?? DEFAULT_VIEWPORT;
    meta.setAttribute("content", MOBILE_VIEWPORT);
    document.body.classList.add(BODY_CLASS);
    return () => {
      meta.setAttribute("content", previous);
      document.body.classList.remove(BODY_CLASS);
    };
  }, []);
}
